import React, { createContext, useContext, useState } from "react";

const VideoCallContext = createContext();

export const useVideoCall = () => {
  const context = useContext(VideoCallContext);
  if (!context) {
    throw new Error("useVideoCall must be used within a VideoCallProvider");
  }
  return context;
};

export const VideoCallProvider = ({ children }) => {
  const [activeCall, setActiveCall] = useState(null);

  const startCall = (appointmentId, role) => {
    setActiveCall({ appointmentId, role });
  };

  const endCall = () => {
    setActiveCall(null);
  };

  return (
    <VideoCallContext.Provider
      value={{
        activeCall,
        startCall,
        endCall,
      }}
    >
      {children}
    </VideoCallContext.Provider>
  );
};

export { VideoCallContext };
